module.exports = __webpack_public_path__ + "assets/img/folder-icon2.564f0327.png";